import { render, staticRenderFns } from "./bind-card.vue?vue&type=template&id=07a2f83a&scoped=true"
import script from "./bind-card.vue?vue&type=script&lang=js"
export * from "./bind-card.vue?vue&type=script&lang=js"
import style0 from "./bind-card.vue?vue&type=style&index=0&id=07a2f83a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a2f83a",
  null
  
)

export default component.exports